export const COOKIE_POLICY_ACCEPT = 'CS/COOKIE_POLICY_ACCEPT';
